"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramsImp = exports.optionsImpl = exports.highlightI = void 0;
// eslint-disable-next-line @typescript-eslint/class-name-casing
var highlightI = /** @class */ (function () {
    function highlightI() {
    }
    return highlightI;
}());
exports.highlightI = highlightI;
// eslint-disable-next-line @typescript-eslint/class-name-casing
var optionsImpl = /** @class */ (function () {
    function optionsImpl() {
    }
    return optionsImpl;
}());
exports.optionsImpl = optionsImpl;
// class containerI{
//     querySelectorAll: (arg0: string): any;
//     hasAttribute: (arg0: string) => any;
// }
// eslint-disable-next-line @typescript-eslint/class-name-casing
var paramsImp = /** @class */ (function () {
    function paramsImp() {
    }
    return paramsImp;
}());
exports.paramsImp = paramsImp;
